import React from 'react';
import {Box} from '@mui/material'

const PersianDayOfWeek = () => {
  const persianWeekDays = ['یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنج‌شنبه', 'جمعه', 'شنبه'];
  const today = new Date();
  const dayOfWeek = today.getDay(); // Sunday = 0, Monday = 1, ..., Saturday = 6
  const currentPersianDay = persianWeekDays[dayOfWeek]; // Adjust if your week starts on a different day

  return <Box>{currentPersianDay}</Box>;
};

export default PersianDayOfWeek;
